//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import ProductDistributionTable from "@/pages/FlashReport/components/ProductDistributionTable.vue";
import CalendarServices from "@/services/calendar-services.js";
import HorizontalLinesChart from "@/components/Charts/HorizontalLinesChart.vue";
import YearComparisonTable from "@/pages/FlashReport/components/YearComparisonTable.vue";
import * as d3 from "d3";
import ExportGraph from "@/services/export-graph.js";

export default {
  name: "ProductDistributionTab",
  components: {
    ProductDistributionTable,
    HorizontalLinesChart,
    YearComparisonTable,
  },
  props: [
    "selectedRetailer",
    "retailerList",
    "fields",
    "fieldId",
    "startDate",
    "endDate",
    "productHierarchyElementId",
    "storeHierarchyElementId",
    "geoHierarchyElementId",
    "productIds",
    "storeIds",
    "employeeIds",
    "employeeName",
  ],
  mounted: async function () {
    BackendServices.getProductHierarchyLevels().then((response) => {
      this.productLevels = response.data;
      this.productLevels.push({ id: null, name: "Produto" });
    });
  },
  data: () => ({
    CalendarServices,
    ExportGraph,
    d3,
    dnDp: "dn",
    totalStores: null,
    productId: null,
    selectedProductLevel: null,
    selectedTableLine: null,
    productLevels: [],
    productDistributionData: [],
    recordsTotalDistributionData: 0,
    graphMode: { yearComparison: true },
    paginationDistributionData: {
      page: 1,
      rowsPerPage: 10,
    },
    linesGraph: {
      width: 1800,
    },
    graphProductHierarchyLevelElementId: null,
    datePeriod: "month",
    yearComparison: {
      mainData: [],
      secondaryData: [],
    },
    linesGraphMargin: {
      top: 30,
      right: 40,
      bottom: 30,
      left: 50,
    },
    export: null,
  }),
  methods: {
    exportYearComparisonGraphTable() {
      this.$refs.yearComparisonGraph.exportData()
    },
    askForDataDnDpTable(event) {
      this.paginationDistributionData.page = event.pagination.page;
      this.paginationDistributionData.rowsPerPage =
        event.pagination.rowsPerPage;
      this.getDnDpTableData();
    },
    getRetailerTotalStores: async function (hierarchy, geography) {
      let response = null;
      let filters = {};
      let retailerName = this.selectedRetailerName;
      let counter = 1;

      if (retailerName) {
        filters[0] = {
          column_key: "retalhista",
          include: [retailerName],
        };
      }

      if (hierarchy) {
        Object.keys(hierarchy).forEach((i) => {
          if (hierarchy[i].length > 0) {
            filters[counter] = { column_key: i, include: hierarchy[i] };
            counter++;
          }
        });
      }

      if (geography) {
        Object.keys(geography).forEach((i) => {
          if (geography[i].length > 0) {
            filters[counter] = { column_key: i, include: geography[i] };
            counter++;
          }
        });
      }

      response = await BackendServices.getStores(
        { page: 1, rowsPerPage: 1 },
        filters
      );

      this.totalStores = response.headers["x-total-count"];
    },
    selectTableLine(event) {
      if (this.selectedProductLevel) {
        this.graphProductHierarchyLevelElementId = event.product.id;
        this.productId = null;
        this.selectedTableLine = event.product.name;
      } else {
        this.graphProductHierarchyLevelElementId = null;
        this.productId = event.product.id;
        this.selectedTableLine = event.product.name;
      }
    },
    async getDnDpTableData() {
      let response = null;

      response = await BackendServices.kpis.getDnDpTable(
        this.startDate,
        this.endDate,
        this.fieldId,
        this.storeHierarchyElementId,
        this.selectedProductLevel,
        this.productHierarchyElementId,
        this.geoHierarchyElementId,
        this.employeeIds,
        this.paginationDistributionData.page,
        this.paginationDistributionData.rowsPerPage
      );

      this.productDistributionData = response.data;
      this.recordsTotalDistributionData = response.headers["x-total-count"];
    },
    async getDnDpTableDataExport() {
      let response = null;
      this.export = Boolean(true);
      response = await BackendServices.kpis.getDnDpTableExport(
        this.startDate,
        this.endDate,
        this.fieldId,
        this.storeHierarchyElementId,
        this.selectedProductLevel,
        this.productHierarchyElementId,
        this.geoHierarchyElementId,
        this.employeeIds,
        this.paginationDistributionData.page,
        this.paginationDistributionData.rowsPerPage,
        this.export
      );

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "export.xlsx"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    async getProductDistribution() {
      if (
        this.productId ||
        this.productHierarchyElementId ||
        this.graphProductHierarchyLevelElementId
      ) {
        let response_py = await BackendServices.kpis.getProductDistribution(
          this.dnDp,
          this.datePeriod,
          this.productId,
          this.productHierarchyElementId == undefined ? this.productHierarchyElementId : null,
          this.geoHierarchyElementId == undefined ? this.geoHierarchyElementId : null,
          this.fieldId,
          this.endDate.year() - 1,
          this.selectedRetailer,
          this.employeeIds,
        );

        this.yearComparison.mainData = response_py.data;

        let response_cy = await BackendServices.kpis.getProductDistribution(
          this.dnDp,
          this.datePeriod,
          this.productId,
          this.productHierarchyElementId == undefined ? this.productHierarchyElementId : null,
          this.geoHierarchyElementId == undefined ? this.geoHierarchyElementId : null,
          this.fieldId,
          this.endDate.year(),
          this.selectedRetailer,
          this.employeeIds,
        );

        this.yearComparison.secondaryData = response_cy.data;

      }
    },
  },
  computed: {
    selectedMetricName: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).name_label;
      } else {
        return null;
      }
    },
    selectedFieldUnit: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).unit_label;
      } else {
        return null;
      }
    },
    selectedMetric: function () {
      if (this.fields.length > 0) {
        return this.fields.find((i) => i.id === this.fieldId).button_label;
      } else {
        return null;
      }
    },
    selectedProductLevelName: function () {
      let result = this.productLevels
        .filter((i) => i.id === this.selectedProductLevel)
        .pop();

      return result ? result.name : "";
    },
    salesFieldsButtonGroup: function () {
      return this.fields.map((i) => ({ label: i.button_label, value: i.id }));
    },
    selectedRetailerName: function () {
      if (this.retailerList) {
        let retailer = this.retailerList
          .filter((i) => i.id === this.selectedRetailer)
          .pop();
        return retailer ? retailer.name : null;
      } else {
        return null;
      }
    },
  },
  watch: {
    //TODO: add product_ids filter to dn_dp table
    // productIds: {
    //   immediate: true,
    //   handler: function () {
    //     this.getDnDpTableData();
    //   },
    // },
    selectedProductLevel: {
      // immediate: true,
      handler: function () {
        this.getDnDpTableData();
      },
    },
    fieldId: {
      immediate: true,
      handler: function () {
        this.$emit("update-field-id", this.fieldId);
        if (this.fieldId) {
          this.getDnDpTableData();
        }
        if (this.productId) {
          this.getProductDistribution();
        }
      },
    },
    selectedRetailer: {
      // immediate: true,
      handler: function () {
        this.$emit("update-selected-retailer", this.selectedRetailer);
        if (this.selectedRetailer.length != 1 && this.datePeriod === "promo_week") {
          this.datePeriod = "month";
        }
        if (this.productId) {
          this.getProductDistribution();
        }
        this.getDnDpTableData();
        this.getRetailerTotalStores(
          this.$store.getters.getStoreHierarchy,
          this.$store.getters.getGeographyHierarchy
        );
      },
    },
    productId: {
      // immediate: true,
      handler: function () {
        this.getProductDistribution();
      },
    },
    productHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.$emit(
          "update-product-hierarchy-element-id",
          this.productHierarchyElementId
        );
        if (this.productId) {
          this.getProductDistribution();
        }
        this.getDnDpTableData();
      },
    },
    storeHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.getRetailerTotalStores(
          this.$store.getters.getStoreHierarchy,
          this.$store.getters.getGeographyHierarchy
        );
        this.getDnDpTableData();
        if (this.productId) {
          this.getProductDistribution();
        }
      },
    },
    geoHierarchyElementId: {
      // immediate: true,
      handler: function () {
        this.getRetailerTotalStores(
          this.$store.getters.getStoreHierarchy,
          this.$store.getters.getGeographyHierarchy
        );
        this.getDnDpTableData();
        if (this.productId) {
          this.getProductDistribution();
        }
      },
    },
    graphProductHierarchyLevelElementId: {
      // immediate: true,
      handler: function () {
        this.getProductDistribution();
      },
    },
    employeeIds: {
      // immediate: true,
      handler: function () {
        this.getDnDpTableData();
        if (this.productId) {
          this.getProductDistribution();
        }
      },
    },
    startDate: {
      // immediate: true,
      handler: function () {
        if (this.startDate.isValid()) {
          this.getDnDpTableData();
          if (this.productId) {
            this.getProductDistribution();
          }
        }
      },
    },
    endDate: {
      // immediate: true,
      handler: function () {
        if (this.endDate.isValid()) {
          this.getDnDpTableData();
          if (this.productId) {
            this.getProductDistribution();
          }
        }
      },
    },
    datePeriod: {
      // immediate: true,
      handler: function () {
        this.getProductDistribution();
      },
    },
    dnDp: {
      // immediate: true,
      handler: function () {
        this.getProductDistribution();
      },
    },
  },
};
